document.addEventListener("alpine:init", () => {
  Alpine.data("ThemeSection_IndexFooter", () => {
    return {
      fabOffset: 0,

      iconOpen: false,
      iconTimer: null,
      iconDelay: 100,

      init() {
        initTeleport(this.$root);
        Alpine.store("modals").register("index-footer", "bottomDrawer");

        this.$watch(
          () => [
            Alpine.store("modals").bottomDrawer.open,
            Alpine.store("modals").bottomDrawer.contents,
          ],
          () => {
            this.$nextTick(() => this.updateFabOffset());

            // keep icon in sync (with delay)
            clearTimeout(this.iconTimer);
            this.iconTimer = setTimeout(() => {
              this.iconOpen = this.isOpen();
            }, this.iconDelay);
          }
        );

        window.addEventListener("resize", () => this.updateFabOffset());

        this.$nextTick(() => {
          this.updateFabOffset();
          this.iconOpen = this.isOpen();
        });
      },

      isOpen() {
        const bd = Alpine.store("modals").bottomDrawer;
        return bd.open && bd.contents === "index-footer";
      },

      toggle() {
        if (this.isOpen()) {
          Alpine.store("modals").close("bottomDrawer");
        } else {
          Alpine.store("modals").open("index-footer");
        }
      },

      updateFabOffset() {
        if (!this.isOpen()) {
          this.fabOffset = 0;
          return;
        }

        const slot = document.getElementById("bottom-drawer-slot");
        if (!slot) {
          this.fabOffset = 0;
          return;
        }

        const height = slot.getBoundingClientRect().height;
        const remPx = parseFloat(
          getComputedStyle(document.documentElement).fontSize
        );

        this.fabOffset = Math.max(0, height - remPx + 30);
      },
    };
  });
});
